import { IAppState } from '../../redux';
import { ECheckServiceStatus } from '../../redux/reducers';

export function selectIsAutoProlongDisabled(state: IAppState): boolean {
  const {
    checkoutInfo: { status },
  } = state;

  return status === ECheckServiceStatus.pending;
}
